import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Customer} from '../../model/Entities/Customer';

@Component({
    selector: 'customer-delete-confirm-dialog',
    templateUrl: './customer-delete-confirm.dialog.component.html',
    styleUrls: ['./customer-delete-confirm.dialog.component.scss']
})
export class CustomerDeleteConfirmDialogComponent {

    customer: Customer;

    constructor(public dialog: MatDialogRef<CustomerDeleteConfirmDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.customer = data.customer;
    }
}



// WEBPACK FOOTER //
// /app/src/CustomersModule/CustomerDeleteConfirmDialogComponent/customer-delete-confirm.dialog.component.ts